

<div class="row" style="min-height: 100px">
  <div class="card">
    <!-- <button type="button" class="btn-close" aria-label="Close"></button> -->

Hello RR
    <div class="card-body">
      <form [formGroup]="merchatstatusform" (ngSubmit)="MerchantStatus(merchatstatusform.value)">


        <div class="row" *ngIf="datetype">

          <div class="col-sm-12">
            <div class="mb-12">

              <label class="form-label">Merchant Status</label>
              <input type="date" class="form-control" placeholder="yyyy-mm-dd" formControlName="Status"
                     [ngClass]="{'is-invalid': isForm1Submitted && form1.Status.errors}">

              <div *ngIf="isForm1Submitted && form1.Status.errors?.required" class="invalid-feedback">
                Please fill this field
              </div>


            </div>
          </div>
        </div>


        <div class="row mt-2">
          <div class="col-sm-12">
            <label for="exampleFormControlTextarea1">Comment</label>
            <textarea class="form-control" rows="3" formControlName="Remark"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.Remark.errors}"></textarea>
            <div *ngIf="isForm1Submitted && form1.Remark.errors?.required" class="invalid-feedback">
              Please fill this field
            </div>
          </div>
        </div>


        <div class="row mt-3 ">
          <div class="col-md-4">
            <button type="submit" class="btn btn-lg btn-primary">Submit</button>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>

